<div class="career-fair-employers">
    <ng-container *ngIf="employersWithLogo.length === 5 then EmployerLogo; else EmployerTag;">
    </ng-container>

    <a
        class="btn btn_link btn_primary"
        routerLink="/events/{{ eventId }}/employers"
        [ngClass]="{
            'space-bottom-md': employersWithLogo.length !== 5
        }"
    >
        {{ 'event overview.See all' | translate }}
    </a>
</div>

<ng-template #EmployerLogo>
    <a
        *ngFor="let employer of employersWithLogo"
        class="avatar avatar-lg avatar-square"
        target="_blank"
        href="/students/app/career-fairs/{{ eventId }}/employers/{{ employer.registration_id }}"
    >
        <img [src]="employer.logo" [alt]="employer.name" />
    </a>
</ng-template>

<ng-template #EmployerTag>
    <a
        *ngFor="let employer of employers"
        class="chip chip-alt_primary chip-sm"
        target="_blank"
        href="/students/app/career-fairs/{{ eventId }}/employers/{{ employer.registration_id }}"
        [tooltip]="employer.name"
    >
        <span class="chip-value">
            {{ employer.name }}
        </span>
    </a>
</ng-template>
